import { render, staticRenderFns } from "./DifferentiatingBenefitsRelevanceSection.vue?vue&type=template&id=39897bab"
import script from "./DifferentiatingBenefitsRelevanceSection.vue?vue&type=script&lang=ts"
export * from "./DifferentiatingBenefitsRelevanceSection.vue?vue&type=script&lang=ts"
import style0 from "./DifferentiatingBenefitsRelevanceSection.vue?vue&type=style&index=0&id=39897bab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports